import React, { useState, useEffect } from "react";
import Layouts from "../../Layouts";
import { FaEye, FaPlus, FaEdit, FaTrash } from "react-icons/fa";
import { FaCirclePlus } from "react-icons/fa6";
import { MdClose, MdSave, MdUpdate } from "react-icons/md";
import { IoCloseOutline } from "react-icons/io5";
import DietPlanViewModal from "./DietPlanViewModal";
import DietPlanFormModal from "./DietPlanFormModal";
import DietService from "../../../Services/DietService";
import { message, Modal } from "antd";

function Dietrician() {
  const [isFormOpen, setIsFormOpen] = useState(false);
  const [isViewOpen, setIsViewOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [masterData, setMasterData] = useState([]);
  const [selectedPlan, setSelectedPlan] = useState(null);

  const storedLoginResult = sessionStorage.getItem("login_result");
  const loginResultObject = storedLoginResult ? JSON.parse(storedLoginResult) : null;

  const getMasterData = async () => {
    setLoading(true);
    try {
      let pay = {
        accountId: loginResultObject.user.account_Id,
        clinicId: loginResultObject.user.clinic_Id,
        status: 1
      };
      let res = await DietService.dietPlanHeaderList(pay);
      setMasterData(res.data);
    } catch (error) {
      console.error("Error fetching master data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getMasterData();
  }, []);

  const handleView = async (id) => {
    setLoading(true);
    try {
      const res = await DietService.dietPlanHeaderGet(id);
      setSelectedPlan(res.data);
      setIsViewOpen(true);
      setIsEditing(false);
    } catch (error) {
      console.error("Error fetching plan details:", error);
      message.error("Failed to load plan details");
    } finally {
      setLoading(false);
    }
  };

  const handleSave = async (finalPayload) => {
    setLoading(true);
    try {
      if (isEditing) {
        await DietService.dietPlanHeaderUpdate({ ...finalPayload, id: selectedPlan.id, status: 1 });
        message.success("Diet plan updated successfully!");
      } else {
        await DietService.dietPlanHeaderSave(finalPayload);
        message.success("Diet plan saved successfully!");
      }
      setIsFormOpen(false);
      setIsViewOpen(false);
      getMasterData();
    } catch (error) {
      console.error("Operation failed", error);
      message.error(`Failed to ${isEditing ? "update" : "save"} diet plan`);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = (id) => {
    Modal.confirm({
      title: "Are you sure you want to delete this diet plan?",
      content: "This action cannot be undone.",
      okText: "Yes, Delete",
      okType: "danger",
      cancelText: "No",
      onOk: async () => {
        setLoading(true);
        try {
          await DietService.dietPlanHeaderDelete(id);
          message.success("Diet plan deleted successfully");
          getMasterData();
        } catch (error) {
          console.error("Delete failed", error);
          message.error("Failed to delete diet plan");
        } finally {
          setLoading(false);
        }
      },
    });
  };

  return (
    <Layouts>
      <div className="bg-white p-4 rounded-xl shadow-sm">
        <div className="flex justify-between cursor-pointer">
          <h2 className="text-lg font-semibold ">Diet Chart List</h2>
          <p
            className=" bg-brand-primaryColor border rounded-md text-white px-2 py-1 font-inter font-semibold flex gap-2 items-center"
            onClick={() => {
              setIsEditing(false);
              setSelectedPlan(null);
              setIsFormOpen(true);
            }}
          >
            <FaCirclePlus className="w-4 h-4" />
            Add
          </p>
        </div>
        <div className="overflow-x-auto mt-5">
          <table className="w-full text-sm">
            <thead>
              <tr className="text-left bg-gray-100">
                <th className="p-3">Title</th>
                <th className="p-3">Date</th>
                <th className="p-3">Status</th>
                <th className="p-3 text-center">Action</th>
              </tr>
            </thead>
            <tbody>
              {masterData.map((item) => (
                <tr key={item.id} className="border-b hover:bg-gray-50 transition">
                  <td className="p-3 font-medium">{item.chartTitle}</td>
                  <td className="p-3 text-gray-600">{item.createDate}</td>
                  <td className="p-3">
                    <span className={`px-3 py-1 rounded-full text-xs font-medium ${item.planStatus === "Active"
                      ? "bg-green-100 text-green-600"
                      : item.planStatus === "Completed"
                        ? "bg-blue-100 text-blue-600"
                        : "bg-red-100 text-red-600"
                      }`}>
                      {item.planStatus}
                    </span>
                  </td>
                  <td className="p-3 text-center">
                    <div className="flex items-center justify-center gap-2">
                      <button
                        onClick={() => handleView(item.id)}
                        className="bg-[#0CB8A1] text-white hover:bg-[#099985] flex gap-2 items-center rounded-md px-3 py-1 text-sm"
                      >
                        <FaEye /> View
                      </button>
                      <button
                        onClick={() => handleDelete(item.id)}
                        className="bg-red-500 text-white hover:bg-red-600 flex gap-2 items-center rounded-md px-3 py-1 text-sm"
                        title="Delete Plan"
                      >
                        <FaTrash />
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <DietPlanFormModal
          isOpen={isFormOpen}
          onClose={() => setIsFormOpen(false)}
          onSave={handleSave}
          loading={loading}
          initialData={isEditing ? selectedPlan : null}
          isEditing={isEditing}
          loginResultObject={loginResultObject}
        />

        <DietPlanViewModal
          isOpen={isViewOpen}
          onClose={() => setIsViewOpen(false)}
          selectedPlan={selectedPlan}
          onEdit={() => {
            setIsViewOpen(false);
            setIsEditing(true);
            setIsFormOpen(true);
          }}
        />
      </div>
    </Layouts>
  );
}

export default Dietrician;

